export const WORKFLOWS_BASE_PATH = 'document';
